import { useState, useRef, useEffect } from "react";
import { IconVideoFilled } from "@tabler/icons-react";
import clsx from "clsx";
import { MediaType } from "../../../store";
import { CircleLoader } from "../../components";

interface GalleryItemProps {
  downloadUrl?: string;
  name: string;
  index: number;
  /** When false, the thumbnail link exposes no downloadable href. */
  downloadable?: boolean;
  onClick: (e: React.MouseEvent, index: number) => void;
  style?: React.CSSProperties;
  onHeightChange?: (index: number, height: number) => void;
}

export const GalleryItem = ({
  downloadUrl,
  name,
  index,
  downloadable = true,
  onClick,
  style,
  onHeightChange,
}: GalleryItemProps) => {

  const regex: RegExp = /\{([^}]+)\}/;
  const match = name.match(regex);
  const isVideo = match?.[1] === MediaType.VIDEO;

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const imgRef = useRef<HTMLImageElement>(null);
  const itemRef = useRef<HTMLAnchorElement>(null);

  useEffect(() => {
    if (imgRef.current?.complete) {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!isLoading && itemRef.current && onHeightChange) {
      onHeightChange(index, itemRef.current.offsetHeight);
    }
  }, [isLoading, index, onHeightChange, style?.width]);

  return (
    <a
      ref={itemRef}
      className="item"
      href={downloadable ? downloadUrl : undefined}
      onClick={(e) => onClick(e, index)}
      style={style}
    >
      {isVideo && <div className="video-icon"><IconVideoFilled /></div>}
      {isLoading && (
        <div className="image-loader">
          <CircleLoader size="small" />
        </div>
      )}
      <img
        ref={imgRef}
        src={downloadUrl}
        alt={name}
        loading="lazy"
        onLoad={() => setIsLoading(false)}
        className={clsx(isLoading && "loading")}
      />
    </a>
  );
};
